export const admins = {
  appBarTitle: "المشرفون",
  list: {
    addNewAdmin: "إضافة مشرف جديد",
    totalStandardAdmins: "إجمالى المشرفين القياسيين",
    table: {
      email: "البريد الإلكتروني",
      status: "الحالة",
      creationDate: "تاريخ الانشاء",
      activationDate: "تاريخ التفعيل",
    },
    status: {
      verification: "تحقق",
      regular: "عادى",
    },
    resetPassword: "إعادة تعيين كلمة المرور",
    resetAdminPassword: {
      sendResetPassword: "إرسال بريد إلكتروني لإعادة تعيين كلمة المرور",
      email: "البريد الإلكتروني",
      emailPlaceholder: "أدخل البريد الإلكتروني",
      emailRequired: "البريد الإلكتروني مطلوب",
      emailValid: "برجاء إدخال بريد إلكتروني صحيح",
      confirmMsg:
        "هل أنت متاكد أنك تريد إرسال بريد إلكتروني لإعادة تعيين كلمة المرور؟",
    },
  },
  adminsForm: {
    addTitle: "إضافة مشرف قياسي",
    email: "البريد الإلكتروني",
    enterEmail: "ادخل البريد الإلكتروني",
    verificationAdmin: "مسؤول التحقق",
    confirmationMsg: "هل أنت متأكد أنك تريد إضافة هذا المشرف؟",
    validations: {
      emailReq: "البريد الإلكتروني مطلوب",
      emailValid: "برجاء إدخال بريد إلكتروني صحيح",
    },
  },
  messages: {
    adminAdded: "تم إضافة المشرف القياسي بنجاح",
    resetPasswordEmailSent:
      "تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور بنجاح ",
  },
};
